


















import Vue from 'vue';
import {APP_VERSION} from "../../config/constants"
import {mapMutations, mapActions, mapState} from "vuex"

export default Vue.extend({

  name: "navbar",  
  data(){
    return {
      version: APP_VERSION
    }
  },


  computed:{
    //state
    ...mapState(["myip"]),
  },

  methods:{
    //setters
    ...mapMutations(["set_sidebar"]),
  }

})
